interface IBusinessCard {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    suffix?: string;
    title?: string;
    email?: string;
    secondEmail?: string;
    phone?: number;
    phoneExt?: number;
    fax?: number;
    cell?: number;
}

class BusinessCard implements IBusinessCard {
    public firstName?: string;
    public middleName?: string;
    public lastName?: string;
    public suffix?: string;
    public title?: string;
    public email?: string;
    public secondEmail?: string;
    public phone?: number;
    public phoneExt?: number;
    public fax?: number;
    public cell?: number;

    constructor(b: IBusinessCard = {}) {
        this.firstName = b.firstName;
        this.middleName = b.middleName;
        this.lastName = b.lastName;
        this.suffix = b.suffix;
        this.title = b.title;
        this.email = b.email;
        this.secondEmail = b.secondEmail;
        this.phone = b.phone;
        this.phoneExt = b.phoneExt;
        this.fax = b.fax;
        this.cell = b.cell;
    }
}

export default BusinessCard;
export { BusinessCard, IBusinessCard };
